import React from "react";
import "./style.css";  

function ProgressBar({bgcolor,progress,height}){
    const Parentdiv = {
        height: height,
        width: '100%',
        backgroundColor: 'whitesmoke',
        borderRadius: 40,
        marginBottom: 20
      }
    
      const Childdiv = {
       height: 22,
        width: `${progress}%`,
        backgroundColor: bgcolor,
        borderRadius:40,
        textAlign: 'right'
      }
    
      const progresstext = {
        padding: 1,
        color: '#fff',
        fontSize: 14
      }
    return(
        <>
            <div style={Parentdiv}>
      <div style={Childdiv}>
        <span style={progresstext}>{`${progress}%`}</span>
      </div>
    </div>

        </>
    )
}

export default ProgressBar;


